export const AWARD_SHOW_YEARS = 3;

export const AWARD_SHOW_ITEMS = 10;
